<div fxLayout="row">
    <div fxLayout="column">
        <table role="presentation">
<!-- check on the submit. we could still do with having the subject data there its just that we dont want the required thing. might be good to rethink how we did this-->
            <tr>
                <td class="field-label">Anonymity Status:</td>
                <th class="fieldValue" *ngIf="ftsuReportObject?.anonymityStatus == 'c'">Reported Confidentially</th>
                <th class="fieldValue" *ngIf="ftsuReportObject?.anonymityStatus == 'r'">Reported a Concern</th>
                <th class="fieldValue" *ngIf="ftsuReportObject?.anonymityStatus == 'a'">Reported Anonymously</th>
            </tr>
            <tr>
                <td class="field-label">Role:</td>
                <th class="fieldValue">
                    <span translate [language]="language" [showTranslation]="showTranslation" [innerHtml]="ftsuReportObject.role"></span>
                </th>
            </tr>
            <tr>
                <td class="field-label">Subject's First Name:</td>
                <td class="fieldValue"><span [innerHtml]="firstName"></span></td>
            </tr>
            <tr>
                <td class="field-label">Subject's Last Name:</td>
                <td class="fieldValue"><span [innerHtml]="lastName"></span></td>
            </tr>
            <tr >
                <td class="field-label">Description of Concern:</td>
                <td class="fieldValue"><span translate [language]="language" [showTranslation]="showTranslation" [innerHtml]="ftsuReportObject.descOfConcerns"></span></td>
            </tr>
            <tr>
                <td class="field-label">Speaking Out Outcome:</td>
                <td class="fieldValue"><span translate [language]="language" [showTranslation]="showTranslation" [innerHtml]="ftsuReportObject.speakingOutcome"></span></td>
            </tr>
            <tr>
                <td class="field-label">Any Immediate Concerns?:</td>
                <td class="fieldValue" *ngIf="ftsuReportObject?.immediateConcern==null || ftsuReportObject?.immediateConcern==undefined"></td>
                <td class="fieldValue" *ngIf="ftsuReportObject?.immediateConcern===true">Yes</td>
                <td class="fieldValue" *ngIf="ftsuReportObject?.immediateConcern===false">No</td>
            </tr>
            <tr>
                <td class="field-label">Professional Group:</td>
                <td class="fieldValue"><span translate [language]="language" [showTranslation]="showTranslation" [innerHtml]="ftsuReportObject.profGroup"></span></td>
            </tr>
        </table>
    </div>
</div>